export default "__VITE_ASSET__CYQhP2po__"